import { render } from "./Canvas.vue?vue&type=template&id=4e22077a&scoped=true&ts=true"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"

import "./Canvas.vue?vue&type=style&index=0&id=4e22077a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e22077a"]])

export default __exports__